namespace $.$$ {
	export class $bog_bzrl_app_let extends $.$bog_bzrl_app_let {}
}
